import styled from "styled-components";

export const Container = styled.div`
  border: 1px solid #d7bb33;
  padding: 15px 15px 20px 15px;
  border-radius: 5px;
`;
